var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-toggle',{staticClass:"button-watch",attrs:{"icon-href":"#flag","active":_vm.active,"size":_vm.size,"title-active":"Снять с контроля","title-inactive":"Поставить на контроль"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }